var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEu = function SvgEu(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21724_19701",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21724_19701)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#102E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99609 2.59961L10.2206 3.29059H10.9472L10.3594 3.71764L10.5839 4.40863L9.99609 3.98158L9.40831 4.40863L9.63282 3.71764L9.04504 3.29059H9.77158L9.99609 2.59961Z",
    fill: "#F9ED65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1992 3.59961L13.4237 4.29059H14.1503L13.5625 4.71764L13.787 5.40863L13.1992 4.98158L12.6114 5.40863L12.8359 4.71764L12.2482 4.29059H12.9747L13.1992 3.59961Z",
    fill: "#F9ED65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3984 6L15.623 6.69098H16.3495L15.7617 7.11803L15.9862 7.80902L15.3984 7.38197L14.8107 7.80902L15.0352 7.11803L14.4474 6.69098H15.1739L15.3984 6Z",
    fill: "#F9ED65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3984 9L16.623 9.69098H17.3495L16.7617 10.118L16.9862 10.809L16.3984 10.382L15.8107 10.809L16.0352 10.118L15.4474 9.69098H16.1739L16.3984 9Z",
    fill: "#F9ED65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99609 15.4004L10.2206 16.0914H10.9472L10.3594 16.5184L10.5839 17.2094L9.99609 16.7824L9.40831 17.2094L9.63282 16.5184L9.04504 16.0914H9.77158L9.99609 15.4004Z",
    fill: "#F9ED65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3984 12L15.623 12.691H16.3495L15.7617 13.118L15.9862 13.809L15.3984 13.382L14.8107 13.809L15.0352 13.118L14.4474 12.691H15.1739L15.3984 12Z",
    fill: "#F9ED65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1992 14.4004L13.4237 15.0914H14.1503L13.5625 15.5184L13.787 16.2094L13.1992 15.7824L12.6114 16.2094L12.8359 15.5184L12.2482 15.0914H12.9747L13.1992 14.4004Z",
    fill: "#F9ED65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79688 14.4004L7.02139 15.0914H7.74793L7.16015 15.5184L7.38466 16.2094L6.79688 15.7824L6.20909 16.2094L6.4336 15.5184L5.84582 15.0914H6.57236L6.79688 14.4004Z",
    fill: "#F9ED65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59766 6L4.82217 6.69098H5.54871L4.96093 7.11803L5.18544 7.80902L4.59766 7.38197L4.00987 7.80902L4.23439 7.11803L3.6466 6.69098H4.37314L4.59766 6Z",
    fill: "#F9ED65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79688 3.59961L7.02139 4.29059H7.74793L7.16015 4.71764L7.38466 5.40863L6.79688 4.98158L6.20909 5.40863L6.4336 4.71764L5.84582 4.29059H6.57236L6.79688 3.59961Z",
    fill: "#F9ED65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59766 9L3.82217 9.69098H4.54871L3.96093 10.118L4.18544 10.809L3.59766 10.382L3.00987 10.809L3.23439 10.118L2.6466 9.69098H3.37314L3.59766 9Z",
    fill: "#F9ED65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59766 12L4.82217 12.691H5.54871L4.96093 13.118L5.18544 13.809L4.59766 13.382L4.00987 13.809L4.23439 13.118L3.6466 12.691H4.37314L4.59766 12Z",
    fill: "#F9ED65"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eu.14830880efc5b3bf22d8ffe59d18d123.svg";